export const SECTIONS = {
  ITERATION_DETAILS: 'iteration-details',
  COHORTS: 'cohorts',
  ROUTING_PLAN_IDS: 'routing-plan-ids',
  FILTER_RULES: 'filter-rules',
  SUPPRESSION_RULES: 'suppression-rules',
  ROUTING_RULES: 'routing-rules',
} as const;

export const ITERATION_DETAILS = {
  TYPE: 'iterationDetails-type',
  COMMUNICATION: 'iterationDetails-communication',
  APPROVAL_RANGE: 'iterationDetails-approval-range',
} as const;
